import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const TikTokIcon = (props) => (
  <svg width={props.size || 16} height={props.size || 16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const COLUMNS = [
  {
    title: "SHOP",
    links: [
      { label: "All Products", to: "/shop", testid: "footer-shop-all" },
      { label: "Lookbook", to: "/lookbook", testid: "footer-lookbook" },
      { label: "Classic Dejon Richh", to: "/collections", testid: "footer-classic" },
      { label: "Classic Tee — $25", to: "/product/classic-dejon-richh-tee", testid: "footer-classic-tee" },
    ],
  },
  {
    title: "SUPPORT",
    links: [
      { label: "Contact", to: "/contact", testid: "footer-contact" },
      { label: "Track Order", to: "/track", testid: "footer-track" },
      { label: "Shipping Policy", to: "/policies/shipping", testid: "footer-shipping" },
      { label: "Returns & Exchanges", to: "/policies/returns", testid: "footer-returns" },
      { label: "FAQ", to: "/policies/faq", testid: "footer-faq" },
    ],
  },
  {
    title: "LEGAL",
    links: [
      { label: "Privacy Policy", to: "/policies/privacy", testid: "footer-privacy" },
      { label: "Terms & Conditions", to: "/policies/terms", testid: "footer-terms" },
      { label: "Admin Login", to: "/admin", testid: "footer-admin" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-wire bg-obsidian noise-overlay" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8 py-16 sm:py-24">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <p className="font-script text-3xl sm:text-4xl text-neutral-100">Dejon Richh</p>
            <p className="mt-6 font-mono text-[11px] tracking-[0.35em] text-neutral-400">
              MORE THAN CLOTHING. IT'S AN OUTFIT.
            </p>
            <div className="mt-10 flex items-center gap-3">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram"
                className="border border-wire p-3 text-neutral-400 transition-colors hover:border-white hover:text-white" aria-label="Instagram">
                <Instagram size={16} strokeWidth={1.5} />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok"
                className="border border-wire p-3 text-neutral-400 transition-colors hover:border-white hover:text-white" aria-label="TikTok">
                <TikTokIcon size={16} />
              </a>
              <Link to="/contact" data-testid="footer-contact-icon"
                className="border border-wire px-4 py-3 font-mono text-[10px] tracking-[0.3em] text-neutral-400 transition-colors hover:border-white hover:text-white">
                CONTACT
              </Link>
            </div>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <p className="font-mono text-[10px] tracking-[0.35em] text-neutral-500">{col.title}</p>
              <ul className="mt-6 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} data-testid={l.testid} className="font-mono text-xs tracking-wider text-neutral-400 transition-colors hover:text-white">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-wire pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[10px] tracking-[0.25em] text-neutral-600">© 2026 DEJON RICHH. ALL RIGHTS RESERVED.</p>
          <p className="font-mono text-[10px] tracking-[0.25em] text-neutral-600">EST. 2026 — SHIPS WORLDWIDE</p>
        </div>
      </div>
    </footer>
  );
}
